import { LoginError } from '@web3auth/auth-adapter'
import { isAxiosError } from 'axios'
import { isLocalUrl, isPermittedUrl } from 'lib/routeUtils'

export const getRedirecURL = () => {
  const currentURL = new URL(window.location.href)
  const redirectTo = currentURL.searchParams.get('redirect_to')
  if (redirectTo && (isLocalUrl(redirectTo) || isPermittedUrl(redirectTo))) {
    return redirectTo
  }
  return window.location.origin
}

export const getErrorMessage = (e: unknown) => {
  if (isAxiosError(e) && e.response?.data.error.code === 'not_found') {
    return 'Failed to login, do you need to create an account?'
  } else if (isAxiosError(e) && e.response?.data?.error?.message) {
    return e.response?.data.error.message
  } else if (isWeb3AuthError(e)) {
    return getWeb3AuthErrorMessage(e)
  } else {
    return 'Something went wrong when trying to login'
  }
}

export const getWeb3AuthErrorMessage = (e: unknown) => {
  const defaultMessage = 'Something went wrong when trying to login'
  if (!isWeb3AuthError(e)) {
    return e instanceof Error ? e.message : defaultMessage
  }

  switch (e.code) {
    case Web3AuthLoginErrorCode.POPUP_CLOSED:
      return 'User closed the login popup'
    default:
      return defaultMessage
  }
}

export enum Web3AuthLoginErrorCode {
  CUSTOM = 5000,
  INVALID_LOGIN_PARAMS = 5111,
  USER_NOT_LOGGED_IN = 5112,
  POPUP_CLOSED = 5113,
  LOGIN_FAILED = 5114,
  POPUP_BLOCKED = 5115,
  MFA_ALREADY_ENABLED = 5116
}

export const isWeb3AuthError = (e: unknown): e is LoginError => e instanceof LoginError
